<template>
	<div class="card mb-3">
		<div class="card-body">
			<div class="row g-3">
				<!-- Поиск -->
				<div :class="hasExtraFilters ? 'col-md-9' : 'col-md-10'">
					<div class="input-group">
						<span class="input-group-text bg-light border-end-0">
							<i class="fas fa-search text-muted"></i>
							<span class="ms-2 d-none d-sm-inline">{{ $t("label-filter") }}</span>
						</span>
						<input
							ref="filterInput"
							type="text"
							class="form-control border-start-0"
							:value="search"
							@input="$emit('update:search', $event.target.value)"
							:placeholder="$t('placeholder-search')"
							:disabled="loading"
						/>
						<button
							v-if="search"
							class="btn btn-outline-secondary d-flex align-items-center px-2"
							type="button"
							@click="$emit('update:search', '')"
							:disabled="loading"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								width="20"
								height="20"
								fill="currentColor"
							>
								<path
									d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z"
								/>
							</svg>
						</button>
					</div>
				</div>
				
				<!-- Доп. фильтры (например, кнопки Git/HG) -->
				<div class="col-md-1" v-if="hasExtraFilters">
					<slot :disabled="loading"></slot>
				</div>

				<!-- Лимит -->
				<div class="col-md-2">
					<div class="input-group">
						<span
							class="input-group-text bg-light d-none d-xl-inline"
							>{{ $t("label-limit") }}</span
						>
						<select
							class="form-select"
							:value="limit"
							@change="$emit('update:limit', $event.target.value)"
							:disabled="loading"
						>
							<option value="25">25</option>
							<option value="50">50</option>
							<option value="100">100</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss"></style>

<script>
export default {
	name: "FilterBar",
	props: {
		search: { type: String, default: "" },
		limit: { type: [String, Number], default: 25 },
		loading: { type: Boolean, default: false },
	},
	emits: [
		"update:search",
		"update:limit",
	],
	data: () => ({
		wasFocused: false,
	}),
	computed: {
		// Проверяем, передал ли родитель контент в дефолтный слот
		hasExtraFilters() {
			return !!this.$slots.default;
		},
	},
	watch: {
		// Когда загрузка завершается (loading: true -> false), возвращаем фокус
		loading(newVal) {
			if (newVal) {
				// Проверяем, является ли наш инпут активным элементом в браузере
				this.wasFocused = (document.activeElement === this.$refs.filterInput);
			} 
			// 2. Когда загрузка ЗАКОНЧИЛАСЬ (false)
			else if (this.wasFocused) {
				this.focusInput();
				this.wasFocused = false; // Сбрасываем флаг
			}
		},
	},
	methods: {
		focusInput() {
			this.$nextTick(() => {
				// Проверяем, существует ли элемент и не заблокирован ли он
				if (this.$refs.filterInput && !this.loading) {
					this.$refs.filterInput.focus();
				}
			});
		},
	},
};
</script>
